import { Box, Typography } from "@mui/material";
import { styles } from "../TracksPageComponents/styles";
import { Role, SubscriptionState } from "../../proto/api_pb";
import { BorderLinearProgress } from "../StorageComponent/styles";
import {
  UserDetailsContext,
  UserDetailsContextInterface,
} from "../../contexts";
import React, { useContext, useEffect, useState } from "react";
import { formatFileSize } from "../../services/trackService";
import { tierStorageMap } from "../../pages/Billing/types";
import { DrawerStorageProps } from "./types";
import { isBillingRequired } from "../../utils/subscriptionBillingUtils";

export const DrawerStorage: React.FC<DrawerStorageProps> = ({
  currentUser,
}) => {
  const [totalStorage, setTotalStorage] = useState(0);
  const { storageUsage, subscriptionTier, subscriptionState } =
    useContext(UserDetailsContext);
  const { isEnterpriseAccount, enterprise } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);

  useEffect(() => {
    if (subscriptionTier && !isEnterpriseAccount) {
      setTotalStorage(tierStorageMap[subscriptionTier].storageValue);
    } else {
      setTotalStorage(enterprise?.storageLimit ?? 0);
    }
  }, [
    subscriptionTier,
    storageUsage,
    isEnterpriseAccount,
    enterprise?.storageLimit,
  ]);

  return (
    <>
      {subscriptionState === SubscriptionState.SUBSCRIPTION_STATE_ON_TRIAL &&
        !isEnterpriseAccount && (
          <Box sx={styles.trialModeContainer}>
            <Typography sx={{ color: "#d28535" }}>Trial Mode</Typography>
          </Box>
        )}
      {currentUser &&
        (!isEnterpriseAccount ||
          Number(enterprise?.role) !== Role.ROLE_ARTIST) && (
          <Box>
            <Box sx={styles.storageDetailsContainer}>
              <Box sx={styles.cloudIconContainer}>
                <img
                  style={{ width: "20px", height: "20px" }}
                  src="/assets/icons/TracksPageIcons/cloud-blank-01.svg"
                  alt=""
                />
              </Box>
              <Box sx={{ width: "80%" }}>
                {!isBillingRequired(subscriptionTier, storageUsage) ||
                isEnterpriseAccount ? (
                  <Typography sx={{ fontSize: "14px" }}>{`${formatFileSize(
                    storageUsage
                  )} of ${formatFileSize(totalStorage)} used`}</Typography>
                ) : (
                  <Typography
                    sx={{ fontSize: "14px" }}
                  >{`Upgrade your subscription`}</Typography>
                )}

                <BorderLinearProgress
                  variant="determinate"
                  value={Math.min((storageUsage / totalStorage) * 100, 100)}
                  sx={{ marginTop: 1 }}
                />
              </Box>
            </Box>
          </Box>
        )}
    </>
  );
};
